import * as moment from 'moment';

const ticksPerMillisecond = 10000;

export const parseDate = (value: number) : Date => {
  return new Date(value * 1000);
}

export const dateToUnixTime = (date: Date) : number => {
  return Math.floor(date.getTime() / 1000);
}

export const getFirstDayOfWeek = (date: Date) : any => {
  // First day of the week is sunday, last is saturday
  return moment(date).add(1, 'day').startOf('week').subtract(1, 'day');
}

export const getLastDayOfWeek = (date: Date) : any => {
  // First day of the week is sunday, last is saturday
  return moment(date).add(1, 'day').endOf('week').subtract(1, 'day');
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/DateHelper.ts